
import { supabase } from '../../supabase';
import { SessionMetrics } from '../types';
import { AuthFilter } from '@/components/analytics/AuthFilterButtons';

/**
 * Get session metrics (duration, bounce rate, pages per session)
 */
export const getSessionMetrics = async (
  startDate: Date,
  endDate: Date,
  authFilter: AuthFilter = 'all'
): Promise<SessionMetrics> => {
  const { data, error } = await supabase.rpc('get_session_metrics', {
    start_date: startDate.toISOString(),
    end_date: endDate.toISOString(),
    auth_filter: authFilter
  });

  if (error) {
    console.error('Error fetching session metrics:', error);
    throw error;
  }

  if (!data || data.length === 0) {
    return {
      avg_session_duration_seconds: 0,
      bounce_rate: 0,
      avg_pages_per_session: 0
    };
  }

  return {
    avg_session_duration_seconds: Number(data[0].avg_session_duration_seconds),
    bounce_rate: Number(data[0].bounce_rate),
    avg_pages_per_session: Number(data[0].avg_pages_per_session)
  };
};
